/** returns international transfers list
@return { Array }
*/
export const getTmxList = state => state.tmxList
export const getTmxListHasMore = state => state.tmxListHasMore
export const getTmxNumberOfProcess = state => state.tmxNumberOfProcess

/** returns tmx status list
@return { Array }
*/
export const getTmxStatusList = state => state.tmxStatusList

/** returns operation details
@return { Array }
*/
export const getOperationDetails = state => {
    return state.operationDetails
}
